import React from 'react';
import cn from '@/utils/cn';

// AIDEV-NOTE: The SPA's text input — the same 2.125rem control as SPADatePicker and the compact
// SPASelect styles, so form rows line up. Focus is a border change, not a ring (see SPAButton).
export const spaInputClass = cn(
  'tw-box-border tw-h-[2.125rem] tw-w-full tw-rounded tw-border tw-border-solid tw-border-spa-border',
  'tw-bg-spa-bg-secondary tw-px-3 tw-py-1.5 tw-text-sm tw-text-spa-on-bg',
  'placeholder:tw-text-spa-tertiary focus:tw-border-spa-accent focus:tw-outline-none',
  // Important: legacy _forms.scss paints text inputs beige on :read-only and :disabled at higher specificity.
  'read-only:!tw-bg-spa-bg-secondary',
  'disabled:tw-cursor-not-allowed disabled:tw-border-spa-bg-disabled disabled:!tw-bg-spa-bg-disabled',
  'disabled:tw-text-spa-disabled',
);

type SPAInputProps = React.InputHTMLAttributes<HTMLInputElement>;

const SPAInput = React.forwardRef<HTMLInputElement, SPAInputProps>(
  ({ className, type = 'text', ...props }, ref) => (
    <input ref={ref} className={cn(spaInputClass, className)} type={type} {...props} />
  ),
);

SPAInput.displayName = 'SPAInput';

export default SPAInput;
